import moment from 'moment'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { Button, Input } from 'reactstrap'
import { createComment } from 'store/Forms/actions'
import AxiosInstance from 'utils/AxiosInstance'

function SubmissionComments({ submissionId }) {
  const dispatch = useDispatch()
  const [comment, setComment] = useState('')
  const [comments, setComments] = useState([])

  const {
    user: { first_name, last_name },
  } = useSelector((store) => store.auth)

  useEffect(() => {
    AxiosInstance.get(`/forms/submission/${submissionId}/comments`).then(
      (data) => setComments(data)
    )
  }, [submissionId])

  const leaveComment = () => {
    dispatch(createComment(submissionId, comment))
    setComment('')
    setComments([
      ...comments,
      { comment, first_name, last_name, is_comment: true },
    ])
  }

  return (
    <div>
      <div className='d-flex flex-column'>
        {comments?.map((comment) => (
          <div
            key={comment.id}
            className='bg-secondary p-3 rounded my-2 d-flex flex-column'
            style={{ width: 'fit-content' }}
          >
            {comment.is_comment ? (
              <>
                <p>{comment.comment}</p>
                <div className='mt-2 d-flex align-items-center'>
                  <i>
                    {comment.first_name} {comment.last_name}
                  </i>
                  <i className='ml-5'>
                    {comment.created_at
                      ? moment(
                          comment.created_at,
                          'YYYY-MM-DD HH:mm:ss'
                        ).format('MM/DD/YYYY HH:mm')
                      : moment().format('MM/DD/YYYY HH:mm')}
                  </i>
                </div>
              </>
            ) : (
              <i>
                {comment.comment}{' '}
                <span className='ml-5'>
                  {comment.created_at
                    ? moment(comment.created_at, 'YYYY-MM-DD HH:mm:ss').format(
                        'MM/DD/YYYY HH:mm'
                      )
                    : moment().format('MM/DD/YYYY HH:mm')}
                </span>
              </i>
            )}
          </div>
        ))}
      </div>
      <div className='d-flex align-items-center mt-5'>
        <Input
          value={comment}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              leaveComment()
            }
          }}
          onChange={(e) => setComment(e.target.value)}
          className='mr-3'
          placeholder='Leave a comment...'
        />

        <Button onClick={leaveComment} className='' color='info' type='button'>
          Send
        </Button>
      </div>
    </div>
  )
}

export default SubmissionComments
